module.exports = __webpack_public_path__ + "img/pers-residence-en-images.e58cae8b.jpg";